module.exports = __webpack_public_path__ + "static/media/lockRSD.c0bf445d.jpeg";